// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"721":"d0e8799a","4312":"d33b57f0","6583":"d0e8799a","7422":"d0e8799a","9735":"d33b57f0","9935":"91c38c5e"}[chunkId] + ".chunk.css";
};